/*
 * imagesAction.js
 * trt_cms2
 *
 * Created by Hisyam on 4/3/2020.
 * Copyright (c) 2020 Terato Tech. All rights reserved.
 */

import {
  ADD_IMAGE,
  ADD_IMAGE_FULFILLED,
  DELETE_IMAGE,
  DELETE_IMAGE_FULFILLED,
  FETCH_IMAGE,
  FETCH_IMAGE_FULFILLED,
  FETCH_IMAGES,
  FETCH_IMAGES_FULFILLED,
  NEW_IMAGE,
  NEW_IMAGE_FULFILLED,
  RESET_REDIRECT_IMAGE,
  SEARCH_IMAGES,
  SEARCH_IMAGES_FULFILLED,
  UPDATE_IMAGE,
  UPDATE_IMAGE_FULFILLED
} from "../types";
import {ofType} from "redux-observable";
import {forkJoin, of} from "rxjs";
import {catchError, debounceTime, filter, map, mapTo, switchMap, withLatestFrom} from "rxjs/operators";
import {ajax} from "rxjs/ajax";
import {IMAGE_API, IMAGE_COLLECTION_API} from "../../config/api";
import {apiHeader, encodeQueryData} from "../../config/helper";
import {returnErrors} from "../messages/messagesAction";
import {addPostCategoryEpic, addPostTagEpic} from "../blogs/blogsAction";

const collectionsOptionAjax$ = state => ajax.getJSON(IMAGE_COLLECTION_API, apiHeader(state))
  .pipe(
    map(response => response.map(collection => ({
      value: collection.id,
      label: collection.name
    })))
  );

export const fetchImages = (limit=12, offset=0, params = {}) => ({type: FETCH_IMAGES, payload: {...params, limit, offset}});
// export const fetchImages = (params = {}) => ({type: FETCH_IMAGES, payload: params});
const fetchImagesFulfilled = payload => ({type: FETCH_IMAGES_FULFILLED, payload});
export const fetchImagesEpic = (action$, state$) => action$.pipe(
  ofType(FETCH_IMAGES),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(([action, state]) => forkJoin({
    images: ajax.getJSON(IMAGE_API + `?${encodeQueryData(action.payload)}`, apiHeader(state)),
    collections: collectionsOptionAjax$(state)
  }).pipe(
    map(response => fetchImagesFulfilled(response)),
    catchError(({response, status}) => of(returnErrors(response, status)))
  ))
);

export const searchImages = (params, offset=0) => ({type: SEARCH_IMAGES, payload: {...params, limit: 12, offset}});
const searchImagesFulfilled = payload => ({type: SEARCH_IMAGES_FULFILLED, payload});
export const searchImagesEpic = (action$, state$) => action$.pipe(
  ofType(SEARCH_IMAGES),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(
    ([action, state]) => ajax.getJSON(IMAGE_API + `?${encodeQueryData(action.payload)}`, apiHeader(state))
      .pipe(
        map(response => searchImagesFulfilled(response)),
        catchError(({response, status}) => of(returnErrors(response, status)))
      )
  )
);

export const newImage = () => ({type: NEW_IMAGE});
const newImageFulfilled = payload => ({type: NEW_IMAGE_FULFILLED, payload});
export const newImageEpic = (action$, state$) => action$.pipe(
  ofType(NEW_IMAGE),
  withLatestFrom(state$),
  switchMap(([, state]) => collectionsOptionAjax$(state).pipe(
    map(response => newImageFulfilled(response)),
    catchError(({response, status}) => of(returnErrors(response, status)))
  ))
);

export const fetchImage = id => ({type: FETCH_IMAGE, payload: id});
const fetchImageFulfilled = payload => ({type: FETCH_IMAGE_FULFILLED, payload});
export const fetchImageEpic = (action$, state$) => action$.pipe(
  ofType(FETCH_IMAGE),
  withLatestFrom(state$),
  switchMap(([action, state]) => forkJoin({
    image: ajax.getJSON(IMAGE_API + `${action.payload}/`, apiHeader(state)),
    collections: collectionsOptionAjax$(state)
  }).pipe(
    map(response => fetchImageFulfilled(response)),
    catchError(({response, status}) => of(returnErrors(response, status)))
  ))
);

export const addImage = image => ({type: ADD_IMAGE, payload: image});
const addImageFulfilled = payload => ({type: ADD_IMAGE_FULFILLED, payload});
export const addImageEpic = (action$, state$) => action$.pipe(
  ofType(ADD_IMAGE),
  withLatestFrom(state$),
  switchMap(([action, state]) => ajax.post(IMAGE_API, action.payload, apiHeader(state, null))
    .pipe(
      map(({response}) => addImageFulfilled(response)),
      catchError(({response, status}) => of(returnErrors(response, status)))
    )
  )
);

export const updateImage = (id, image) => ({type: UPDATE_IMAGE, payload: image, id});
const updateImageFulfilled = payload => ({type: UPDATE_IMAGE_FULFILLED, payload});
export const updateImageEpic = (action$, state$) => action$.pipe(
  ofType(UPDATE_IMAGE),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(([action, state]) => ajax.patch(IMAGE_API + `${action.id}/`, action.payload, apiHeader(state, null))
    .pipe(
      map(({response}) => updateImageFulfilled(response)),
      catchError(({response, status}) => of(returnErrors(response, status)))
    )
  )
);

export const deleteImage = id => ({type: DELETE_IMAGE, id});
const deleteImageFulfilled = id => ({type: DELETE_IMAGE_FULFILLED, payload: id});
export const deleteImageEpic = (action$, state$) => action$.pipe(
  ofType(DELETE_IMAGE),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(
    ([action, state]) => ajax.delete(IMAGE_API + `${action.id}/`, apiHeader(state))
      .pipe(
        map(() => deleteImageFulfilled(action.id)),
        catchError(({response, status}) => of(returnErrors(response, status)))
      )
  )
);

export const resetRedirectImageEpic = action$ => action$.pipe(
  ofType(ADD_IMAGE_FULFILLED, UPDATE_IMAGE_FULFILLED, DELETE_IMAGE_FULFILLED),
  mapTo({type: RESET_REDIRECT_IMAGE})
);

export const imagesEpic = [
  fetchImagesEpic,
  fetchImageEpic,
  newImageEpic,
  addImageEpic,
  updateImageEpic,
  deleteImageEpic,
  resetRedirectImageEpic,
  searchImagesEpic,
  addPostCategoryEpic,
  addPostTagEpic,
];